import { POST_CARD_APPLY_START } from '../../types';

export const post_card_apply = (payload) => ({
  type: POST_CARD_APPLY_START,
  payload,
});
